import { Link } from 'react-router-dom'

import styles from './Button.module.scss'

import { Spinner } from '@/components/Spinner'

type ButtonBaseProps = {
  title: string | React.ReactNode
  type: 'dark' | 'light' | 'destructive' | 'link' | 'destructiveLight'
  isDisabled?: boolean
  isLoading?: boolean
  width?: number
  className?: string
  htmlType?: 'button' | 'submit' | 'reset'
  ariaLabel?: string
}

// Either a real action (onClick, renders <button>) or pure navigation
// (to, renders a real <Link>/<a> so right-click/middle-click/screen readers
// see it as a link, not a button that happens to navigate).
type ButtonProps = ButtonBaseProps & ({ onClick: () => void; to?: undefined } | { to: string; onClick?: () => void })

const buttonStyle = {
  dark: styles.dark,
  light: styles.light,
  destructive: styles.destructive,
  destructiveLight: styles.destructiveLight,
  link: styles.link,
}

const Button = (props: ButtonProps) => {
  const { title, onClick, type, isDisabled, isLoading, width, className, htmlType = 'button', ariaLabel, to } =
    props
  const classNames = `${styles.container} ${buttonStyle[type]} ${isDisabled || isLoading ? styles.disabled : ''} ${className}`

  if (to && !isDisabled && !isLoading) {
    return (
      <Link to={to} className={classNames} style={{ width }} onClick={onClick} aria-label={ariaLabel}>
        {title}
      </Link>
    )
  }

  return (
    <button
      type={htmlType}
      className={classNames}
      onClick={isDisabled || isLoading ? undefined : onClick}
      disabled={isDisabled || isLoading}
      style={{ width }}
      aria-label={ariaLabel}
    >
      {title}
      {isLoading && <Spinner size={20} />}
    </button>
  )
}

export default Button
